import { render, staticRenderFns } from "./QuestionDetailContent.vue?vue&type=template&id=2e394500"
import script from "./QuestionDetailContent.vue?vue&type=script&lang=ts"
export * from "./QuestionDetailContent.vue?vue&type=script&lang=ts"
import style0 from "./QuestionDetailContent.vue?vue&type=style&index=0&id=2e394500&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_css-loader@6.11.0_lodash@4.17.21_prettier@2.2.1__svvz7rxqjs6qp55qupdfm65wwi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports